import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=bb074096&scoped=true"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&id=bb074096&prod&lang=scss&scoped=true"
import style1 from "./DocumentForm.vue?vue&type=style&index=1&id=bb074096&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bb074096",
  null
  
)

export default component.exports